import { DeliveryStatus } from '../constants/DeliveryStatus';
import { UndeliverableReasons } from '../../metrics2/models/enumerations/UndeliverableReason';
import { DeliveryStatusToUndeliveredReasonMap } from './getDeliveryBadge/GetDeliveryBadgeMappings';
import FinishedDelivery from '../models/entities/FinishedDelivery';
import { personDeliveryRule, putDownOutside } from './getDeliveryBadge/GetDeliveryBadge';
import CustomerTrackingData from '../models/types/CustomerTrackingData';
import { BadgeAbbreviation, badgeDictionary } from '@components/delivery-badge/types';
import DeliveryModes from '../models/enumerations/DeliveryMode';

const KNOWN_STATUSES = new Set<string>(Object.values(DeliveryStatus));

export const mapItemStatus = (
  s: DeliveryStatus,
  finishedDelivery: FinishedDelivery,
  customer?: CustomerTrackingData
) => {
  if ((s as unknown as BadgeAbbreviation) === 'OE' || (s as unknown as BadgeAbbreviation) === 'NB') {
    return badgeDictionary[s];
  }

  if (personDeliveryRule.shouldApply(finishedDelivery)) {
    return personDeliveryRule.getValue(finishedDelivery, customer);
  } else if (putDownOutside.shouldApply(finishedDelivery)) {
    return putDownOutside.getValue(finishedDelivery);
  }
  // LMAJSM-880: a raw status with no badge code (e.g. RESTBESTAND_LIEGENGEBLIEBEN) at a PaketShop stop
  // shows the stop's own badge, like a parcel without a status, instead of the grey default.
  if (!KNOWN_STATUSES.has(s) && finishedDelivery?.deliveryMode === DeliveryModes.paketShop) {
    return badgeDictionary.PS;
  }
  switch (s) {
    case DeliveryStatus.Abgabe_PS:
      return badgeDictionary.PS;
    case DeliveryStatus.Ret_Mit:
      return badgeDictionary.RET;
    case DeliveryStatus.RL_N1:
      return badgeDictionary.N1;
    case DeliveryStatus.RL_N2:
      return badgeDictionary.N2;
    case DeliveryStatus.RL_N3:
      return badgeDictionary.N3;
    case DeliveryStatus.RL_N4:
      return badgeDictionary.N4;
    case DeliveryStatus.RL_T1:
      return badgeDictionary.T1;
    case DeliveryStatus.RL_T2:
      return badgeDictionary.T2;
    case DeliveryStatus.RL_T3:
      return badgeDictionary.T3;
    case DeliveryStatus.RL_T4:
      return badgeDictionary.T4;
    case DeliveryStatus.SEZ_Medea:
      return badgeDictionary.SEZ;
    case DeliveryStatus.RL_S:
      return badgeDictionary.S;
    case DeliveryStatus.RL_Storno:
      return {
        ...badgeDictionary.RL,
        description: 'Rücklauf',
        color: 'red',
      };
    case DeliveryStatus.RL_U:
      return badgeDictionary.U;
    case DeliveryStatus.RL_F:
      return badgeDictionary.F;
    default:
      return UndeliverableReasons[DeliveryStatusToUndeliveredReasonMap[s]] ?? badgeDictionary.default;
  }
};
